import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { closeAllModal, showModal, showNestedModal } from "../../features/modal/modalSlice"
import Button from "../shared/Button"
import { useState } from "react"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../hooks/useScrollLock"
import { deleteEgeyurtIletisimItem, getEgeyurtIletisimItemData } from "../../features/admin/adminSlice"

const Container = styled.div`

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 10px 60px 40px;
            line-height: 1.4;
            text-align: center;
            
            .red{
              color: var(--color-dark-red);
              font-weight: var(--font-weight-xl);
              font-size: 18px;

            }
        }

        .button-grp{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin: 20px 0;
        }
    }
`
const DeleteEgeyurtIletisimBirimPermissionModal = () => {
  const { egeyurtIletisimItemData} = useSelector(state => state.admin)
  const { modalLocation} = useSelector(state => state.modal)
  const { lockScroll, unlockScroll } = useScrollLock();

  const dispatch = useDispatch()
  const location = useLocation()

           //! bu modal açıldığnda ekran ı lock lamak için
           useEffect(() => {
            lockScroll()
    
            return () => {
                unlockScroll()
            }
        }, [lockScroll, unlockScroll])
    
        //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
        useEffect(() => {
            if (location.pathname !== modalLocation) {
                dispatch(showModal(null))
            }
        }, [dispatch, location.pathname, modalLocation])



  return (
    <Container onClick={()=> dispatch(showModal(null))}>
      <div className="modal" onClick={(e)=> e.stopPropagation() }>
        <p><span className="red">{egeyurtIletisimItemData.tittle}</span> ismine sahip, <span className="red">{egeyurtIletisimItemData.phoneNumber}</span> telefon numaralı Ege Yurt iletişim Birimini Silmek istediğinize emin misiniz?</p>
        <div className="button-grp">
                <Button color={"#F4F4F4"} background={"#FF0000"} width="260px" radius={"10px"} text={"İletişim Birimini Sil"} handleClick={()=> dispatch(deleteEgeyurtIletisimItem({id:egeyurtIletisimItemData.id}))}/>
                <Button color={"#F4F4F4"} background={"#0EAC00"} width="260px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
      </div>
    </Container>
  )
}

export default DeleteEgeyurtIletisimBirimPermissionModal